import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import agenda from '../../images/event/EMC-agenda.jpg'
import { COLORS } from '../../styles/theme'
import agenda1 from 'src/images/event/agenda-1.png'
import agenda2 from 'src/images/event/agenda-2.png'
import styled from 'styled-components'

const StyledModal = styled(Modal)`
  .modal-content {
    border: 2px solid ${COLORS.primaryLight};
    box-shadow: 0px 4px 12px ${COLORS.lightGray1};
  }
  .modal-body {
    padding: 0;
  }
  .agenda {
    button {
      margin: 0 16px;
      background: ${COLORS.brightGreen};
      border: 2px solid ${COLORS.lightGreen};
      font-weight: 500;
      border-radius: 12px;
      padding: 4px 12px;
      color: ${COLORS.hotButtonText};
      font-size: 16px;

      &:hover {
        background: ${COLORS.green};
      }
    }
    .active {
      font-style: italic;
      color: #002060;
      text-decoration: underline;
    }
  }
`

export default function SpeakersModal({ showModal, hideModal }) {
  const [agenda, setAgenda] = useState(1);

  return (
    <StyledModal show={showModal} onHide={hideModal} size="lg" aria-labelledby="speakers-bio" centered>
      <Modal.Body>
        <div className="p-3">
          <div className="agenda mb-3">
            <button className={`${agenda === 1 && 'active'}`} onClick={()=>setAgenda(1)}>Day 1</button>
            <button className={`${agenda === 2 && 'active'}`} onClick={()=>setAgenda(2)}>Day 2</button>
          </div>

          { agenda === 1 && <img src={agenda1} className="w-100 mb-2" /> }
          { agenda === 2 && <img src={agenda2} className="w-100 mb-2" /> }
        </div>
      </Modal.Body>
    </StyledModal>
  )
}
